<template>
  <div v-if="DATA_IS_LOADED" class="view home">
    <div class="view__inner home__inner">
      <hero v-if="heroText" :msg="heroText" :fullpage="true" :link-to-dept="true" />

      <div class="frontpage-cases">
        <frontpage-case-slide :id="item.id" v-for="item in frontPageCases" :key="item.id" />
      </div>

      <logos :content="logos" />
    </div>

    <the-site-footer-new :boring="true" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Hero from "@/components/Hero.vue";
import FrontpageCaseSlide from "@/components/FrontpageCaseSlide.vue";
import JobBoard from "@/components/JobBoard.vue";
import Logos from "@/components/Logos.vue";
import TheSiteFooterNew from "@/components/TheSiteFooterNew.vue";

export default {
  name: "home",
  components: {
    Hero,
    FrontpageCaseSlide,
    JobBoard,
    Logos,
    TheSiteFooterNew
  },
  computed: mapState({
    DATA_IS_LOADED: state => state.data.isLoaded,
    heroText: state => {
      if (state.data && state.data.home) {
        return state.data.home.manifesto;
      }
    },
    frontPageCases: state => {
      if (state.data && state.data.cases) {
        return state.data.cases.filter(item => item.frontpage);
      }
    },
    logos: state => {
      if (state.data && state.data.logos) {
        return {
          title: state.data.logos.title,
          paragraph: state.data.logos.text,
          items: state.data.logos.item
        };
      }
    }
  }),
  methods: {
    senseScroll() {
      this.$store.commit("firstPageLoad");
    }
  },
  mounted() {
    this.$store.commit("SET_LIGHT_THEME", false);

    setTimeout(() => this.$store.commit("firstPageLoad"), 2000);
  },
  destroyed() {
    this.$store.commit("clearFrontpageCases");
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.home {
  z-index: 2;
  height: 100vh;

  .mobile & {
    height: auto;
  }

  .home__inner {
    position: relative;
    z-index: 0;
  }
}
</style>
